import React, { Fragment, useCallback } from "react";
import PropTypes from "prop-types";
import { Field } from "redux-form";
import { Col } from "react-bootstrap";
import {
  Check,
  CheckGroup,
  RadioGroupField
} from "MODULES/shared/components/Forms";
import {
  ASSIGN_TO_ME,
  LOCKED,
  LOOKING_FOR,
  OFFER
} from "MODULES/OutgoingQuotes/constants";
import { properCase } from "LIB/formatters/text";
import FormRow from "MODULES/shared/components/Forms/FormRow";

const options = [
  {
    text: "None",
    value: ""
  },
  {
    text: "No Interest",
    value: "no_interest"
  },
  {
    text: "Looking For",
    value: LOOKING_FOR
  }
];

export default function OfferFields({ resetFields, required, disabled }) {
  const onChange = useCallback((_, newValue) => {
    if (newValue !== LOOKING_FOR) {
      resetFields();
    }
  }, []);

  return (
    <Fragment>
      <FormRow>
        <Col sm={8} md={8}>
          <Field
            name={OFFER}
            label={properCase(OFFER)}
            component={RadioGroupField}
            onChange={onChange}
            options={options}
            required={required}
            disabled={disabled}
          />
        </Col>
        <Col md={4}>
          <CheckGroup
            title="Lock Outgoing Quote"
            info="Outgoing Quote will be locked for 72 hours."
          >
            <Field
              name={LOCKED}
              component={Check}
              label={properCase(ASSIGN_TO_ME)}
            />
          </CheckGroup>
        </Col>
      </FormRow>
    </Fragment>
  );
}

OfferFields.propTypes = {
  resetFields: PropTypes.func.isRequired,
  required: PropTypes.bool,
  disabled: PropTypes.bool
};



// WEBPACK FOOTER //
// ./app/modules/OutgoingQuotes/shared/OfferFields.jsx